<script>
  // Render html component for render html with vue components inside
  export default {
    props: {
      html: {
        type: String,
        required: true,
      },
    },
    render(h) {
      const render = {
        components: {
          ContactButton: () =>
            import(/* webpackChunkName: "chunk-contact-button" */ './contact-button.vue'),
          UiButton: () => import(/* webpackChunkName: "chunk-ui-button" */ './ui/ui-button.vue'),
          AgeVerificationLock: () =>
            import(
              /* webpackChunkName: "chunk-age-verification-lock" */ './age-verification/age-verification-lock.vue'
            ),
          SvgMcvVerified: () =>
            import(/* webpackChunkName: "chunk-svg-mcv-verified" */ './svg/mcv-verified.vue'),
          VerifiedBadgeFooter: () =>
            import(
              /* webpackChunkName: "chunk-verified-badge-footer" */ '../components/verified-badge-footer.vue'
            ),
          UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
          SvgImageVerifiedAnimation: () =>
            import(
              /* webpackChunkName: "chunk-svg-image-verified-animation" */ './svg/image-verified-animation.vue'
            ),
        },
        template: '<div>' + this.html + '</div>',
      }
      return h(render)
    },
  }
</script>
